// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"232b2090","542":"a483f3b1","557":"845e062a","709":"ad09d82d","948":"d580aa2e"}[chunkId] + ".chunk.js";
};